import Factory from '../factory';

const schema = Factory.schema('ebulletins');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('title').setType(String).setValue('');

export default schema;
